import yup from '../yup-extended';

export const dateStringSchema = yup
    .string()
    .trim()
    .validDate({ excludeEmptyString: true })
    .transform((value) => (value === '..' ? '' : value));
export const birthdaySchema = dateStringSchema
    .label('Geburtsdatum')
    .notInFuture({ excludeEmptyString: true })
    .minAge(18, { excludeEmptyString: true })
    .maxAge(120, { excludeEmptyString: true });
export const switchingDateSchema = dateStringSchema
    .label('Schaltungstermin')
    .switchingDate({ excludeEmptyString: true });
